export const lightTheme = {
    mode: 'light',
    palette: {
        neutral: {
            darkest: '#f5f5f7',
            dark: '#f0f0f0',
            medium: '#7a7a7a',
            lightest: '#171717',
            darkRgb: '245,245,247',
        },
        primary: {
            darkest: '#33299e26',
            dark: '#33299e59',
            medium: '#33299eb3',
            light: '#33299e',
            darkRgb: '51,41,158',
        },
        success: {
            darkest: '#22c55e10',
            medium: '#16a34a',
            light: '#22c55e',
            lightest: '#4ade80',
        },
        error: {
            medium: '#ef4444',
        },
        particles: {
            medium: '#33299e',
        },
        background: '#dcd7f7',
        button: {
            primary: {
                background: '#33299e',
                text: '#fafafa'
            },
            secondary: {
                background: '#f6f4fd',
                text: '#2d2d2e'
            }
        },
        cart: {
            background: '#e8e4fa',
            item: {
                background: '#fafafa',
                border: '#f5f5f7'
            }
        },
        info: {
            cardWrapper: '#e8e4fa'
        },
        product: {
            color: '#f5f5f7',
            discount: {
                color: '#fafafa'
            }
        }
    },
};

export const darkTheme = {
    mode: 'dark',
    palette: {
        neutral: {
            darkest: '#0a0a0a',
            dark: '#181818',
            medium: '#d4d4d44d',
            lightest: '#fafafa',
            darkRgb: '24,24,24',
        },
        primary: {
            darkest: '#33299e33',
            dark: '#33299e80',
            medium: '#33299ed9',
            light: '#33299e',
            darkRgb: '51,41,158',
        },
        success: {
            darkest: '#22c55e19',
            medium: '#22c55e',
            light: '#34d399',
            lightest: '#6ee7b7',
        },
        error: {
            medium: '#f43f5e',
        },
        particles: {
            medium: '#3232A8',
        },
        background: '#0a0a0a',
        button: {
            primary: {
                background: '#33299e',
                text: '#fafafa'
            },
            secondary: {
                background: '#181818',
                text: '#fafafa'
            }
        },
        cart: {
            background: '#1c1c1c',
            item: {
                background: '#202122',
                border: '#262626'
            }
        },
        info: {
            cardWrapper: '#0a0a0a'
        },
        product: {
            color: '#0a0a0a',
            discount: {
                color: '#fafafa'
            }
        }
    },
};

export type ThemeType = typeof darkTheme;
